
import { styled } from '@mui/material/styles';
import { Box, Typography, Link, Popover } from '@mui/material';

export const StyledPopover = styled(Popover)(({ theme }) => ({
  '& .MuiPaper-root': {
    width: '400px',
    maxWidth: '90vw',
    borderRadius: '12px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
  },
}));

export const DrawerHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const HeaderTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1rem',
  color: theme.palette.text.primary,
}));

export const NotificationList = styled(Box)(({ theme }) => ({
  maxHeight: '400px',
  overflowY: 'auto',
  padding: theme.spacing(1),
}));

export const MarkAllLink = styled(Link)(({ theme }) => ({
  fontSize: '0.8rem',
  color: theme.palette.primary.main,
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const NotificationItemContainer = styled(Box)<{ statusColor: string; isRead: boolean }>(({ theme, statusColor, isRead }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  padding: theme.spacing(2),
  marginBottom: theme.spacing(1),
  backgroundColor: isRead ? theme.palette.common.white : '#f0f7ff', // Light blue for unread
  borderRadius: '8px',
  position: 'relative',
  overflow: 'hidden',
  cursor: 'pointer',

  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },

  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '6px',
    backgroundColor: statusColor,
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '8px',
  },
}));

export const ItemContent = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(1.5),
  flex: 1,
}));

export const DeleteButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0.5),
  cursor: 'pointer',
  color: theme.palette.grey[400],
  '&:hover': {
    color: theme.palette.error.main,
  },
}));

export const NotificationMessage = styled(Typography)(({ theme }) => ({
  fontSize: '0.9rem',
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(0.5),
  lineHeight: 1.4,
}));

export const TimeText = styled(Typography)(({ theme }) => ({
  fontSize: '0.75rem',
  color: theme.palette.grey[500],
  fontStyle: 'italic',
}));

export const DrawerFooter = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: 'center',
  borderTop: `1px solid ${theme.palette.grey[200]}`,
}));

export const SeeAllLink = styled(Link)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '0.9rem',
  color: theme.palette.primary.main,
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
}));
